module.exports = __webpack_public_path__ + "img/009-team.e995a4e9.png";